// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Contas_AccountSummaryResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /contas/account_summary/{id}
 *
 * The `dados` payload IS the flat account-summary shape — the full conta
 * fields enriched with three transaction stats and the validation block,
 * exactly as Contas_model::account_summary() returns it (busca_conta()
 * output + stats + validation).
 *
 * Uses the default getDados() (no override): the public typed properties
 * below ARE the dados object, so the generated runtime schema validates
 * every field. Mirrors Contas_AccountSummaryRow.
 */
import type { Contas_ContaUsuarioRow } from './Contas_ContaUsuarioRow'
import type { Contas_ContaValidationRow } from './Contas_ContaValidationRow'
import type { Contas_FormaPagamentoRow } from './Contas_FormaPagamentoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Contas_AccountSummaryResponseDados {
conta_id: number
conta_nome: string
conta_status: number
conta_franquia_nome: string
conta_tipo: string
conta_permite_gerar_link_pagto: number
conta_provedor: string
formas_pagamento: Contas_FormaPagamentoRow[]
usuarios: Contas_ContaUsuarioRow[]
transaction_count: number
total_received: number
conta_data_cadastro?: string
conta_franquia_id?: number
conta_id_externo?: string
last_transaction_date?: string
validation?: Contas_ContaValidationRow
}

export type Contas_AccountSummaryResponse = ApiResponse<Contas_AccountSummaryResponseDados>;

registerResponseContract('Contas_AccountSummaryResponse', {
  conta_id:                       { type: 'number',  required: true },
  conta_nome:                     { type: 'string',  required: true },
  conta_status:                   { type: 'number',  required: true },
  conta_franquia_nome:            { type: 'string',  required: true },
  conta_tipo:                     { type: 'string',  required: true },
  conta_permite_gerar_link_pagto: { type: 'number',  required: true },
  conta_provedor:                 { type: 'string',  required: true },
  formas_pagamento: {
    type: 'array',
    required: true,
    items: {
      forma_pagamento_id:   { type: 'number',  required: true },
      forma_pagamento_nome: { type: 'string',  required: false },
    },
  },
  usuarios: {
    type: 'array',
    required: true,
    items: {
      usuario_id:                { type: 'string',  required: false },
      usuario_nome:              { type: 'string',  required: false },
      status:                    { type: 'number',  required: false },
      permite_lancar_pagamentos: { type: 'number',  required: false },
      permite_ver_relatorios:    { type: 'number',  required: false },
      permite_gerar_link_pagto:  { type: 'number',  required: false },
    },
  },
  transaction_count:              { type: 'number',  required: true },
  total_received:                 { type: 'number',  required: true },
  conta_data_cadastro:            { type: 'string',  required: false },
  conta_franquia_id:              { type: 'number',  required: false },
  conta_id_externo:               { type: 'string',  required: false },
  last_transaction_date:          { type: 'string',  required: false },
  validation: {
    type: 'object',
    required: false,
    fields: {
      is_complete:         { type: 'boolean', required: false },
      is_active:           { type: 'boolean', required: false },
      has_payment_methods: { type: 'boolean', required: false },
      has_users:           { type: 'boolean', required: false },
      issues:              { type: 'array',   required: false },
    },
  },
})
